import React from 'react';
import '../styles/EdcatoButton.css';
import EdcatoLogo from '../../../../assets/solutions/edcato/Edcato.svg';

const EdcatoButton = () => {
  const handleClick = () => {
    window.open('https://www.edcato.com/', '_blank', 'noopener,noreferrer');
  };

  return (
    <div className="edcato-button-container">
      <button 
        className="edcato-button"
        onClick={handleClick}
        aria-label="Visit Edcato website to transform your digital experience"
      >
        <div className="edcato-button-content">
          <img 
            src={EdcatoLogo} 
            alt="Edcato Logo" 
            className="edcato-logo"
          />
          <span className="edcato-text">
            Transform your digital experience with Edcato
          </span>
        </div>
        <div className="edcato-button-glow"></div>
      </button>
    </div>
  );
};

export default EdcatoButton;